import React, { Fragment, FunctionComponent, useEffect, useState } from 'react';
import { ApplicationState } from '../../../redux/States';
import { ErrorDispatches } from '../../../redux/Dispatches';
import { ConnectedProps, connect } from 'react-redux';
import { Cell, Row, downloadSheets, generateSheet } from '../../../utils';
import XLSX, { Range } from 'xlsx-js-style';
import { Button, Row as BSRow, Col, Table, DropdownButton, Dropdown } from 'react-bootstrap';
import { AuthedLayout } from '../../../components';
import { TeeGradeClassStatistic, UserInfo } from '../../../model';
import { useSemGrade, useInspectionType } from '../../../hook';
import apis from '../../../apis';
import { toast } from 'react-toastify';



const borderStyle = { color: { rgb: '000000' }, style: 'thin' } as const;
const fullBorderStyle = {
    top: borderStyle,
    bottom: borderStyle,
    left: borderStyle,
    right: borderStyle,
} as const;
const cellAlignStyle = {
    horizontal: 'center',
    vertical: 'center',
} as const;

const mapState = (state: ApplicationState) => ({ ...state.auth });
const mapDispatches = ErrorDispatches;

const connector = connect(mapState, mapDispatches);

type Props = ConnectedProps<typeof connector>;


const teeClassStatic: FunctionComponent<Props> = ({ catchErrorForModal }) => {
    const { yearSem, element } = useSemGrade();
    const { inspectiontype, inspectionTypeDP } = useInspectionType({
        yearSem,
        catchErrorForModal,
    });
    const [datas, setDatas] = useState<TeeGradeClassStatistic[]>([]);
    const [userinfo, setUser] = useState<UserInfo>();
    useEffect(() => {
        if (yearSem && inspectiontype) {
            apis.getUserInfo()
                .then((u) => {
                    setUser(u);
                })
                .catch(catchErrorForModal);

            toast
                .promise(
                    apis.getTeethTeeClassStatic(yearSem.year, yearSem.sem)
                        .then((r) =>
                            setDatas(r)
                        ),
                    {
                        pending: '資料載入中......',
                        success: '資料載入成功！',
                        error: '資料載入失敗！請查看錯誤資訊。',
                    }
                )
        }
    }, [yearSem?.year, yearSem?.sem, inspectiontype]);

    const gradeBase = datas.reduce((grades, d) => {
        if (inspectiontype == "複檢") {
            if (d.total) {
                d.total.tsheetadultCount = d.total?.reTsheetadultCount ?? 0;
                d.total.tsheetchildrenCount = d.total?.reTsheetchildrenCount ?? 0;
            }
        }
        return { ...grades, [d.grade]: [...(grades[d.grade] || []), d] };
    }, {} as Record<number, TeeGradeClassStatistic[]>);
    const physicalGrades = Array.from(
        new Set(
            Object.values(gradeBase)
                .flat()
                .filter((item) => item.isPhysical)
                .map((item) => item.grade)
        )
    )
        .sort((a, b) => a - b);
    let schoolcount = 0;
    let schoolT01count = 0;
    let schoolTsheetadultCount = 0;
    let schoolTsheetchildrenCount = 0;

    const contentRows: Row[] = Object.values(gradeBase).flatMap(
        (gs, idx, allArray) => {
            const classTee = {
                grade: 0,
                classNo: 0,
                totalCount: 0,
                totalCountT01: 0,
                tsheetadultCount: 0,
                tsheetchildrenCount: 0
            };
            const rows = gs.flatMap((g, idx) => {
                return TeeToRows(
                    g.grade,
                    g.className,
                    g.total?.count ?? 0,
                    g.total?.countT01 ?? 0,
                    g.total?.tsheetadultCount ?? 0,
                    g.total?.tsheetchildrenCount ?? 0,
                    idx === 0 ? { row: (gs.length + 1) } : undefined
                );
            });
            gs.forEach(tee => {
                classTee.totalCount += tee.total?.count ?? 0,
                    classTee.totalCountT01 += tee.total?.countT01 ?? 0,
                    classTee.tsheetadultCount += tee.total?.tsheetadultCount ?? 0,
                    classTee.tsheetchildrenCount += tee.total?.tsheetchildrenCount ?? 0,
                    schoolcount += tee.total?.count ?? 0
                schoolT01count += tee.total?.countT01 ?? 0
                schoolTsheetadultCount += tee.total?.tsheetadultCount ?? 0
                schoolTsheetchildrenCount += tee.total?.tsheetchildrenCount ?? 0
            });
            rows.push(...TeeToRows('', '小計', classTee.totalCount, classTee.totalCountT01, classTee.tsheetadultCount, classTee.tsheetchildrenCount));
            if (idx === allArray.length - 1) {
                const lastRow = rows[rows.length - 1];

                lastRow.cells = lastRow?.cells.map((c) => {
                    const { style: { border = {} } = {} } = c;
                    border.bottom = borderStyle;
                    c.style = { ...c.style, border };
                    return c;
                });
            }

            return rows;
        }
    );
    const content: Row[] = [
        {
            cells: [
                {
                    value: '年級班級',
                    merge: { column: 2 },
                    style: { border: fullBorderStyle },
                },
                {
                    value: '人數',
                    merge: { column: 1 },
                    style: { border: fullBorderStyle },
                },
                {
                    value: '未治療齲齒人數A',
                    merge: { column: 1 },
                    style: { border: fullBorderStyle },
                },
                {
                    value: '未治療齲齒比率',
                    merge: { column: 1 },
                    style: { border: fullBorderStyle },
                },
                {
                    value: 'DMFT(恆齒) B',
                    merge: { column: 1 },
                    style: { border: fullBorderStyle },
                },
                {
                    value: '恆齒指數',
                    merge: { column: 1 },
                    style: { border: fullBorderStyle },
                },
                {
                    value: 'deft(乳齒) C',
                    merge: { column: 1 },
                    style: { border: fullBorderStyle },
                },
                {
                    value: '乳齒指數',
                    merge: { column: 1 },
                    style: { border: fullBorderStyle },
                },
            ],
        },
        ...contentRows,
        ...TeeToRows('全校合計', '', schoolcount, schoolT01count, schoolTsheetadultCount, schoolTsheetchildrenCount, { column: 2, row: 2 }),
    ];

    const handlePrint = () => {
        const printWindow = window.open(
            '',
            '_blank',
            'width=1400,height=900'
        );

        if (!printWindow) {
            alert('瀏覽器阻擋了列印視窗，請允許彈出式視窗。');
            return;
        }

        const escapeHtml = (value: unknown): string => {
            return String(value ?? '')
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#039;');
        };

        const title =
            `${yearSem?.year}學年第${yearSem?.sem}學期_口腔檢查結果統計表(含恆乳齒指數)`;

        const tableRows = content
            .map((row) => {
                const cells = row.cells
                    .map((cell) => {
                        if (cell.value === undefined) {
                            return '';
                        }

                        const colSpan = cell.merge?.column
                            ? ` colspan="${cell.merge.column}"`
                            : '';

                        const rowSpan = cell.merge?.row
                            ? ` rowspan="${cell.merge.row}"`
                            : '';

                        return `
                        <td${colSpan}${rowSpan}>
                            ${escapeHtml(cell.value)}
                        </td>
                    `;
                    })
                    .join('');

                return `<tr>${cells}</tr>`;
            })
            .join('');

        printWindow.document.open();

        printWindow.document.write(`
        <!DOCTYPE html>
        <html lang="zh-Hant">
        <head>
            <meta charset="UTF-8" />
            <title>${escapeHtml(title)}</title>

            <style>
                * {
                    box-sizing: border-box;
                }

                html,
                body {
                    margin: 0;
                    padding: 0;
                    font-family:
                        "Microsoft JhengHei",
                        "Noto Sans TC",
                        Arial,
                        sans-serif;
                    color: #000;
                }

                .print-page {
                    min-height: 190mm;
                    display: flex;
                    flex-direction: column;
                }

                h1 {
                    margin: 0 0 10px;
                    text-align: center;
                    font-size: 18px;
                }

                .description {
                    margin-bottom: 5px;
                    font-size: 11px;
                }

                table {
                    width: 100%;
                    border-collapse: collapse;
                    table-layout: fixed;
                    margin-top: 10px;
                }

                td {
                    border: 1px solid #000;
                    padding: 5px 2px;
                    text-align: center;
                    vertical-align: middle;
                    font-size: 10px;
                    word-break: break-word;
                }

                .footer {
    margin-top: auto;
    padding-top: 16px;
    font-size: 12px;
    display: flex;
    justify-content: space-between;
    width: 100%;
}

                @page {
                    size: A4 landscape;
                    margin: 8mm;
                }

                @media print {
                    body {
                        padding: 0;
                    }

                    tr {
                        page-break-inside: avoid;
                        break-inside: avoid;
                    }
                }
            </style>
        </head>

        <body>
            <div class="print-page">

                <h1>${escapeHtml(title)}</h1>

                <div class="description">
                    一、A：未治療齲齒人數（未治療齲齒資料代號為 1、3）
                </div>

                <div class="description">
                    二、B：DMFT(恆齒)（口檢表恆牙上，資料代號為 d、f、m、D、F、M）
                </div>

                <div class="description">
                    三、C：deft(乳齒)（口檢表乳牙上，資料代號為 d、f、m、D、F、M）
                </div>

                <table>
                    <tbody>
                        ${tableRows}
                    </tbody>
                </table>

                <div class="footer">
  <span>承辦人:</span>
  <span>組長:</span>
  <span>主任:</span>
  <span>校長:</span>
</div>

            </div>

            <script>
                window.onload = function () {
                    window.focus();

                    setTimeout(function () {
                        window.print();
                    }, 300);
                };

                window.onafterprint = function () {
                    window.close();
                };
            </script>
        </body>
        </html>
    `);

        printWindow.document.close();
    };

    // const workSheet = generateSheet(content, { alignment: cellAlignStyle });
    return (
        <AuthedLayout>
            <BSRow className="justify-content-between">
                <Col>
                    <BSRow>
                        <Col xs={3} className="mr-3">
                            {element}
                        </Col>
                        <Col xs={3} className="mr-3" >
                            {inspectionTypeDP}
                        </Col>
                        <Col xs={3} className="mr-3" >
                            {physicalGrades.length > 0 && (

                                <span style={{ color: 'red' }}>
                                    ※ 提示：{physicalGrades.join('、')} 年級的資料來自健檢口腔資料
                                </span>
                            )}
                        </Col>
                    </BSRow>
                </Col>
                <div>
                    <DropdownButton
                        id="tee-class-static-export"
                        title="匯出"
                        variant="success"
                        disabled={!datas.length}
                    >
                        <Dropdown.Item
                            onClick={() => {
                                const workSheet = generateSheet(
                                    [
                                        {
                                            cells: [
                                                {
                                                    value: `${yearSem?.year}學年第${yearSem?.sem}學期_口腔檢查結果統計表(含恆乳齒指數)`,
                                                    style: { alignment: { horizontal: 'left' } },
                                                },
                                            ],
                                        },
                                        {
                                            cells: [
                                                {
                                                    value: '一、A：未治療齲齒人數（未治療齲齒資料代號為 1、3）',
                                                    merge: { column: 7 },
                                                    style: { alignment: { horizontal: 'left' } },
                                                }
                                            ]
                                        },
                                        {
                                            cells: [
                                                {
                                                    value: '二、B：DMFT(恆齒)（口檢表恆牙上，資料代號為 d、f、m、D、F、M）',
                                                    merge: { column: 7 },
                                                    style: { alignment: { horizontal: 'left' } },
                                                }
                                            ]
                                        },
                                        {
                                            cells: [
                                                {
                                                    value: '三、C：deft(乳齒)（口檢表乳牙上，資料代號為 d、f、m、D、F、M）',
                                                    merge: { column: 7 },
                                                    style: { alignment: { horizontal: 'left' } },
                                                }
                                            ]
                                        },
                                        ...content,
                                        {
                                            cells: [
                                                {
                                                    value:
                                                        '承辦人:　　　　　　　　　　　　　組長:　　　　　　　　　　　　　主任:　　　　　　　　　　　　　　校長:　　　　　　　　　　　　',
                                                    style: { alignment: { horizontal: 'left' } },
                                                },
                                            ],
                                        },
                                    ],
                                    {
                                        alignment: cellAlignStyle,
                                    }
                                );

                                downloadSheets(
                                    '口腔檢查結果統計表(含恆乳齒指數)',
                                    userinfo?.exportFileType,
                                    {
                                        sheet: workSheet,
                                        name: 'st'
                                    }
                                );
                            }}
                        >
                            Excel 下載
                        </Dropdown.Item>

                        <Dropdown.Item onClick={handlePrint}>
                            列印
                        </Dropdown.Item>
                    </DropdownButton>
                </div>
            </BSRow>
            <hr />
            <BSRow>
                <Table
                    striped
                    bordered
                    className="text-center"
                    style={{ tableLayout: 'fixed' }}
                >
                    <colgroup>
                        <col style={{ width: '3%' }} />
                        <col style={{ width: '3%' }} />
                        <col style={{ width: '7%' }} />
                        <col style={{ width: '7%' }} />
                        <col style={{ width: '7%' }} />
                        <col style={{ width: '7%' }} />
                        <col style={{ width: '7%' }} />
                        <col style={{ width: '7%' }} />
                        <col style={{ width: '7%' }} />
                    </colgroup>
                    <tbody>
                        {content.map((r, i) => {
                            const cells = r.cells.map((c, j) =>
                                c.value != undefined ? (
                                    <td
                                        colSpan={c.merge?.column}
                                        rowSpan={c.merge?.row}
                                        key={`${i}-${j}`}
                                    >
                                        {c.value}
                                    </td>
                                ) : (
                                    <Fragment key={`${i}-${j}`}></Fragment>
                                )
                            );
                            return <tr key={i}>{cells}</tr>;
                        })}
                    </tbody>
                </Table>
            </BSRow>
        </AuthedLayout>
    );
};

function TeeToRows(
    grade: number | string,
    classNo: number | string,
    totalCount: number,
    totalCountT01: number,
    tsheetadultCount: number,
    tsheetchildrenCount: number,
    gradeMerge?: { row?: number; column?: number }
): Row[] {
    // const parsedClassNo = (() => {
    //     const num = parseInt(classNo as string, 10);
    //     return !isNaN(num) && num > 100 && num < 200 ? num - 100 : classNo;
    // })();
    const gradeNo = [
        {
            value: gradeMerge ? grade : undefined,
            merge: gradeMerge,
            style: { border: fullBorderStyle },
        },
    ];
    if (!gradeMerge?.column) {
        gradeNo.push({
            value: classNo,
            merge: { row: 1 },
            style: { border: fullBorderStyle },
        });
    }
    return [
        {
            cells: [
                ...gradeNo,
                {
                    value: totalCount ?? 0,
                    style: { border: { left: borderStyle } },
                },
                {
                    value: totalCountT01 ?? 0,
                },
                {
                    value: percent(totalCountT01, totalCount),
                    style: { border: { right: borderStyle } },
                },
                {
                    value: tsheetadultCount ?? 0,
                },
                {
                    value: tsheetadultCount == 0 ? 0 : parseFloat((tsheetadultCount / totalCount).toFixed(2)),
                },
                {
                    value: tsheetchildrenCount ?? 0,
                },
                {
                    value: tsheetchildrenCount == 0 ? 0 : parseFloat((tsheetchildrenCount / totalCount).toFixed(2)),
                },
            ],
        },

    ];
}

function percent(value: number, denominator: number): string {
    if (!denominator) return '0.00%';
    return ((value / denominator) * 100).toFixed(2) + '%';
}




export const TeeClassStatic = connector(teeClassStatic);
